import { render, staticRenderFns } from "./RiepilogoFattPerCliente.vue?vue&type=template&id=9bf210a0&scoped=true&"
import script from "./RiepilogoFattPerCliente.vue?vue&type=script&lang=js&"
export * from "./RiepilogoFattPerCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf210a0",
  null
  
)

export default component.exports